<template>
  <element>
    <AppBar :title="title" />

    <div class="parts-list" v-bind:class="{ 'part-list-expanded': isPartMenuOpen, 'part-list-collapsed': !isPartMenuOpen }">
      <b-container class="pt-0 mt-0 pl-1 ml-0 pr-2 mr-0 pb-0 mb-0">
        <b-row no-gutters class="text-left"><!-- menu header -->
          <b-col class="col-3">
            <span class="part-count-badge">{{ scannedParts.length }}</span>
          </b-col>
          <b-col class="col-4">
            <span class="part-list-label">Parts</span>
          </b-col>
          <v-spacer></v-spacer>
          <b-col  class="col-3 text-right">
            <span class="part-list-toggle-btn">
              <v-icon @click="expandPartMenu" class="part-list-chevron-down" color="lightgrey" medium>mdi-chevron-down</v-icon>
              <v-icon @click="collapsePartMenu" class="part-list-close" color="lightgrey" medium>mdi-close</v-icon>
            </span>
          </b-col>
        </b-row> <!-- /menu header -->
        <div class="part-list-group">
        <b-row v-for="part in scannedParts" :key="part.part_id" no-gutters class="mt-2 pt-2 pr-1 part-item"> <!-- part item -->
          <b-col cols="2">
            <img :src="'/api/v1/PartDocuments/get?is_thumb=1&raw=1&get_first=1&document_type_id=3&part_id=' + part.part_id" onerror="this.style.visibility='hidden'" class="part-item-picture">
          </b-col>
          <b-col cols="9">
            <b-row no-gutters>
              <b-col cols="12"><span class="part-item-oem-number">{{ part.oem_number}}</span></b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="12" class="text-truncate"><span class="part-item-name">{{ part.name }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="1" class="part-item-delete-icon" @click="removePart(part.part_id)">
            <v-icon small>mdi-trash-can-outline</v-icon>
          </b-col>
        </b-row> <!-- / part item -->
        </div>
      </b-container>
    </div> <!-- /part list -->

    <div class="full-screen-underlay">
      <div class="camera-frame">
        <img class="corner-top-left" src="../assets/camera-frame-corner.svg">
        <img class="corner-top-right" src="../assets/camera-frame-corner.svg">
        <img class="corner-bottom-left" src="../assets/camera-frame-corner.svg">
        <img class="corner-bottom-right" src="../assets/camera-frame-corner.svg">
      </div>
      <div class="top-linear-gradient"></div>
      <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>        
      <div class="bottom-linear-gradient"></div>
    </div>

    <v-container class="pl-0 pr-0 pt-0 pb-0" fluid>
      <v-row no-gutters class="first-line mt-2 mr-2 ml-2">
        <v-spacer></v-spacer>
        <v-col class="col-4 col-sm-3">
          <p class="scanned-position mb-0 mt-1"> 
            <v-icon small color="purple">
              mdi-map-marker
            </v-icon>  
            {{ this.decodedWarehouseLocation }} 
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4 align-center justify-content-center second-line">
        <v-spacer></v-spacer>
        <v-col class="position-relative col-10 col-sm-5 col-md-5 col-lg-5">
          <p class="scanned-part mb-0">
            {{ part_name }} 
          </p>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row no-gutters class="pt-0 mt-0">
        <v-col class="col-12">
          <p class="scan-error-message" v-if="isPartInvalid">{{ $t('scanPart.scan_error') }}</p>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4 align-center justify-content-center">
        <v-col class="position-relative">

        </v-col>
      </v-row>
    </v-container>
    <div class="action-buttons-bottom">
      
      <v-btn
      class="mx-2 blue"
      fab
      dark
      medium
      color="blue"
      @click="addNewLocation"
    >
        <v-icon dark>
          {{ warehouse_location_icon }}
        </v-icon>
      </v-btn>

      <v-btn
      class="mx-2"
      fab
      dark
      x-large
      :disabled="!scannedParts.length"
      color="green"
      @click="completeProcess"
    >
        <v-icon dark>
          mdi-checkbox-marked-circle-outline
        </v-icon>
      </v-btn>

      <v-btn
      class="mx-2 blue"
      fab
      dark
      medium
      color="blue"
      :disabled ="this.isPartInvalid"
      @click="addPart"
    >
        <v-icon dark>
          mdi-qrcode-plus
        </v-icon>
      </v-btn>

    </div>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import { QrcodeStream  } from 'vue-qrcode-reader';

export default {
  name: "ScanPartPage",
  components: {
    AppBar,
    QrcodeStream ,
  },
  data () {
    return {
      qrcode:null,
      qrcodeJson:null,
      isPartInvalid: true,
      warehouse_location: null,
      part_name:null,
      part_ids:[], // this is an array storing the part_id that were selected by the user
      scannedParts:[], // we store parts scanned by the user here
      decodedWarehouseLocation:null,
      variables:{},
      isPartMenuOpen: false,
    }
  },
  props: {

  },
  created(){
    /* todo: make sure to test that $store is defined in the this context before accessing */
    this.title = this.$store.getters.getCurrentTask.taskName;
    const pid = this.$store.getters.getCurrentPID
    // we retrieve process variables
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.warehouse_location = response.data.data.warehouse_location.value
        let warehouse_location_object = JSON.parse(this.warehouse_location)
        console.log('warehouse location', this.warehouse_location);
        // we validate the json object
        if (this.validateLocation(warehouse_location_object, 'warehouse'))
        {
          this.decodedWarehouseLocation = warehouse_location_object.location.aisle + '-' + warehouse_location_object.location.unit + '-' + warehouse_location_object.location.shelf + '-' + warehouse_location_object.location.bin
        }
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
  },
  methods: {
    onDecode (decodedString) {
      this.qrcode = null
      this.qrcodeJson = null
      try {
        this.qrcode = JSON.parse(decodedString);
        this.qrcodeJson = decodedString
        this.part_name = this.qrcode.name
      } catch(e) {
        console.log('scanned qr code is not a json string', decodedString)
        this.isPartInvalid = true
        this.decodedWarehouseLocation=''
        this.qrcodeJson = null
      }
      if (this.qrcode)
      {
        // we validate the json object
        if (this.validateScan(this.qrcode, 'part'))
        {
          console.log('part id:', this.qrcode.part_id)
        }
      }
    },
    validateLocation(qrcode, type='warehouse')
    {
      if (typeof qrcode.location ==undefined || typeof qrcode.type ==undefined)
      {
        this.isLocationInvalid = true
        return false
      }

      if (qrcode.type == type)
      {
        this.isLocationInvalid = false
        return true
      } else {
        this.isLocationInvalid = true
        return false
      }
    },
    validateScan(qrcode, type='part')
    {
      if (typeof qrcode.part_id == undefined || typeof qrcode.type == undefined || typeof qrcode.name == undefined)
      {
        this.isPartInvalid = true
        return false
      }

      if (qrcode.type == type)
      {
        this.isPartInvalid = false
        return true
      } else {
        this.isPartInvalid = true
        return false
      }
    },
    isPartInList(object, criteria){
      for (const part of object)
      {
        if (part.part_id == criteria) {
          return true
        }
      }
      return false
    },
    addPart(){
      // we test if the item isn't already in the list
      if ( !(this.isPartInList(this.scannedParts, this.qrcode.part_id)) ) {
        this.scannedParts.push(this.qrcode);
      }
    },
    preparePartIds(){
      this.part_ids = []
      for (const scannedPart of this.scannedParts) {
        this.part_ids.push(parseInt(scannedPart.part_id))
      }
      console.log('preparePartIds(): ', this.part_ids)

    },
    addNewLocation(){
      this.preparePartIds()
      console.log('part_ids:', this.part_ids)
      this.variables =  {
        "variables": {
          "part_id": {
            "value": JSON.stringify(this.part_ids),
            "type": "String"
          },
          "part_count":{
            "value": this.part_ids.length,
            "type":"Integer"
          },
          "scan_new_warehouse_location":{
            "value": true,
            "type": "Boolean"
          }
        }
      }

      this.sendTaskComplete()
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        console.log(error)
      }
    },
    completeProcess(){
      this.preparePartIds()
      console.log('part_ids:', this.part_ids)
      this.variables =  {
        "variables": {
          "part_id": {
            "value": JSON.stringify(this.part_ids),
            "type": "String"
          },
          "part_count":{
            "value": this.part_ids.length,
            "type":"Integer"
          },
          "scan_new_warehouse_location":{
            "value": false,
            "type": "Boolean"
          }
        }
      }

      this.sendTaskComplete()
    },
    sendTaskComplete() {     
      const taskId = this.$store.getters.getCurrentTask?.id
      const variables = this.variables

      console.log('variables: ', variables)

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    },
    expandPartMenu() {
      console.log('expandPartMenu()')
      this.isPartMenuOpen = true
    },
    collapsePartMenu() {
      console.log('collapsePartMenu()')
      this.isPartMenuOpen = false
    },
    removePart(id){
      console.log('removePart():', id)
      this.scannedParts.forEach(function(item, index, object) {
        if (item.part_id === id) {
          object.splice(index, 1);
        }
      });
    }
    
  },
  computed: {
    warehouse_location_icon() {
      if (this.scannedParts.length > 0)
      {
        return "mdi-map-marker-plus-outline"
      } else {
        return "mdi-map-marker-left-outline"
      }
    }
  }
}
</script>

<style scoped>

.blue {
  background-color: #033E8C !important;
}
.full-screen-underlay {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 0;
    background-color: black; 
  }

.scanned-part {
    background-color: #616161d6;
    color: white;
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    font-family: Rubik;
    font-size: 1.5rem;
    min-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.scanned-position {
    background-color: #616161d6;
    color: white;
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: Rubik;
    text-transform: uppercase;
}

.v-icon {
  color: white !important;
  vertical-align: inherit;
}

.v-btn--fab.v-size--x-large .v-icon {
  font-size: 50px;
}

.scan-error-message {
  color: red;
}

.top-linear-gradient {
  /* Black gradient mask (top) */
    position: absolute;
    width: 100vw;
    height: 350px;
    left: 0px;
    top: 0px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 38%, rgba(0, 0, 0, 0) 93%);
    z-index: 1;
}

.bottom-linear-gradient {
  /* Black gradient mask (bottom) */
  position: absolute;
  width: 100vw;
  height: 250px;
  left: 0px;
  bottom: 0px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 18%, rgba(0, 0, 0, 0) 80%);
  transform: matrix(1, 0, 0, -1, 0, 0);
}

.action-buttons-bottom {
  position: absolute;
  bottom: 5%;
  text-align: center;
  width: 100vw;
  margin-bottom:20px;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: green;
}

.camera-frame {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    opacity: 0.7;
}

.camera-frame > .corner-top-left {
    position: absolute;
    float: left;
    left: 10%;
    top: 30%;
}

.camera-frame > .corner-top-right {
    position: absolute;
    float: right;
    right: 15%;
    top: 30%;
    transform: rotate(90deg);
}

.camera-frame > .corner-bottom-left {
    position: absolute;
    float: left;
    left: 10%;
    top: 75%;
    transform: rotate(-90deg);
}

.camera-frame > .corner-bottom-right {
    position: relative;
    float: right;
    right: 15%;
    top: 75%;
    transform: rotate(180deg);
}

.parts-list {
  position: absolute;
  top:60px;
  left: 10px;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  z-index: 999;
  padding: 5px;
  min-height: 35px;
  transition: width 0.3s;
}

.part-list-collapsed {
  height: 35px;
  width: 120px;
  overflow: hidden;
}

.part-list-expanded {
  height: auto;
  width: 350px;
}

@media screen and (max-width: 376px) {
  .part-list-expanded {
    width: 90%;
}
}

.part-list-collapsed .part-list-toggle-btn > .part-list-close {
  display: none;
}

.part-list-collapsed .part-list-toggle-btn > .part-list-chevron-down {
  display: inherit;
}

.part-list-expanded .part-list-toggle-btn > .part-list-chevron-down {
  display: none;
}

.part-list-expanded .part-list-toggle-btn > .part-list-close {
  display: inherit;
}

.part-count-badge {
  height: 20px;
  min-height: 20px;
  min-width: 20px;
  background: #4CAF50;
  border-radius: 20px;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  padding: 4px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  line-height: 12px;
}

.part-list-label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  display: inline-block;
  color: #000000;
}

.part-list-toggle-btn > .v-icon {
  color: grey !important;
  font-size: 16px;
}

.part-item-picture {
  height: 45px;
  width: 45px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.part-item-oem-number {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 100%;
  color: rgba(0, 0, 0, 0.63);
}

.part-item-name {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  color: #000000;
  text-overflow: ellipsis;
}

.part-item-delete-icon {
  height: auto;
  text-align: right;
}

.part-item-delete-icon > i {
  width: 10px;
  color: red !important; 
}

.part-item {
  border-top: 1px solid lightgray;
  text-align: left !important;
}

.part-list-group {
  max-height: 400px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.parts-list.part-list-collapsed .part-list-group {
  display: none;
}
</style>

<style>
/* td #139 fixes the blurred video stream */
/* the app .overlay conflicts with the vue-qrcode-viewer overlay class */
/* #208 https://github.com/gruhn/vue-qrcode-reader/issues/208 */
/* td 202010231205 updated vue-qrcode-reader to 2.3.14 that solves the issue */
/*
.overlay {
  -webkit-backdrop-filter: blur(0px) !important;
  backdrop-filter: blur(0px) !important;
  background: transparent !important;
}
*/
</style>